export default __webpack_public_path__ + "static/media/address.b8d08e88.svg";